import { CmdLoader } from '@commander-services/gui-components';
import { useRecoilValue } from 'recoil';
import { LanguagesContext } from './LanguagesContext';
import JWTService from '../Services/JWTService';
import Toastr from './Toastr';
import { isLoggedIn } from '../Services/UserService';
import { setLoaderAtom } from '../store/recoil/AppState';
import Login from './Login';

function RideMapLayout({ component: Component }: any): JSX.Element {
  const showLoader = useRecoilValue<boolean>(setLoaderAtom);

  if (isLoggedIn() && !JWTService.isTokenExpired()) {
    return (
      <div id="application">
        <Toastr />
        <Component />
        {showLoader && <CmdLoader inContent={true} />}
      </div>
    );
  }

  return (
    <LanguagesContext.Consumer>
      {(context) => <Login context={context} />}
    </LanguagesContext.Consumer>
  );
}

export default RideMapLayout;
